/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Patient API
 * API for Patient
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PatientCommentTypename = "PatientComment" as const;

/**
 *
 * @export
 * @interface PatientComment
 */
export interface PatientComment {
  /**
   *
   * @type {string}
   * @memberof PatientComment
   */
  content?: string;
  /**
   *
   * @type {string}
   * @memberof PatientComment
   */
  from?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PatientComment
   */
  readonly __typename?: string;
}

export function PatientCommentFromJSON(json: any): PatientComment {
  return PatientCommentFromJSONTyped(json, false);
}

export function PatientCommentFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientComment {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PatientCommentTypename,

    content: !exists(json, "content") ? undefined : json["content"],
    from: !exists(json, "from") ? undefined : json["from"],
  };
}

export function PatientCommentToJSON(object?: PatientComment | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    content: value.content,
    from: value.from,
  };
}
